import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import { StatsMutation } from "../common/home/Stats";
import {
  getTransactions,
  getOlderTransactions,
  getdetailTransaction,
} from "../../core/service/api_transaction";
import moment from "moment";
import { formatCurrency } from "../../config/global";
import { Transition } from "@headlessui/react";
import { t } from "i18next";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import CustomApp from "../../core/models/customApp";
import { format } from "path";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentTransactionHistory = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [transaction, setTransaction] = useState([]);
  const [detailTransaction, setDetailTransaction] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [years, setYears] = useState(moment().format("YYYY"));
  const [month, setMonth] = useState(moment().format("MM"));
  const [transactionName, setTransactionName] = useState("");
  const [sizeA, setSizeA] = useState(10);
  const [pageA, setPageA] = useState(0);
  const [totalA, setTotalA] = useState(0);
  const [balanceIn, setBalanceIn] = useState(0);
  const [balanceOut, setBalanceOut] = useState(0);
  const [balanceInOld, setBalanceInOld] = useState(0);
  const [balanceOutOld, setBalanceOutOld] = useState(0);
  const [sizeB, setSizeB] = useState(10);
  const [pageB, setPageB] = useState(0);
  const [totalB, setTotalB] = useState(0);
  const [showDetail, setShowDetail] = useState(false);
  const [detail, setDetail] = useState<any>({});
  const [trans, setTrans] = useState(true);
  const [transactionOlder, setTransactionOlder] = useState([]);
  const { t } = useTranslation();
  const year = moment().format("YYYY");
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  const [monthOption, setMonthOption] = useState<any>([]);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("MM"));
  const [yearOption, setYearOption] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM"));
  const [selectedDateOld, setSelectedDateOld] = useState(
    moment().subtract(3, "months").format("YYYY-MM")
  );
  const [bulanOld, setBulanOld] = useState(
    moment().subtract(3, "month").format("MMMM")
  );
  const [selectedYear, setSelectedYear] = useState(year);
  const user: User = useAppSelector((state) => state.user.user);
  var yearArray: any = [];
  const monthArray: any = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const minOffset = 0;
  const maxOffset = 10;
  const [date, setDate] = useState(moment().format("MM"));
  const [yearr, setYearr] = useState(moment().format("YYYY"));
  const [tahun, setTahun] = useState(moment().format("YYYY"));
  const [bulan, setBulan] = useState(moment().format("MM"));
  const [tahunOld, setTahunOld] = useState(
    moment().subtract(3, "month").format("YYYY")
  );

  useEffect(() => {
    var dateNow = moment().format("MM");
    var year = moment().format("YYYY");

    getHistory(dateNow, year);
  }, []);

  const getHistory = async (month: string, year: string) => {
    setTrans(true);
    dispatch(setLoading(true));
    getTransactions(month, year)
      .then((res: any) => {
        console.log(res, "total");
        setTransaction(res.data.content);
        let tempIn = 0;
        let tempOut = 0;
        res.data.content.forEach((s: any) => {
          if (s.amount.toString().substring(0, 1) == "-") {
            tempIn -= s.amount;
          } else {
            tempOut += s.amount;
          }
        });
        setBalanceIn(tempIn);
        setBalanceOut(tempOut);
        setTotalA(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        navigate("/login", { replace: true });
        dispatch(setLoading(false));
      });
  };

  const changePageA = (newPage: any) => {
    setPageA(newPage);
    dispatch(setLoading(true));
    getTransactions(month, year)
      .then((res: any) => {
        console.log(res, "total");
        setTransaction(res.data.content);
        let tempIn = 0;
        let tempOut = 0;
        res.data.content.forEach((s: any) => {
          if (s.amount.toString().substring(0, 1) == "-") {
            tempIn -= s.amount;
          } else {
            tempOut += s.amount;
          }
        });
        setBalanceIn(tempIn);
        setBalanceOut(tempOut);
        setTotalA(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        navigate("/login", { replace: true });
        dispatch(setLoading(false));
      });
  };

  const changeSizeA = (newSize: any) => {
    setSizeA(newSize);
    dispatch(setLoading(true));
    getTransactions(month, year)
      .then((res: any) => {
        console.log(res, "total");
        setTransaction(res.data.content);
        let tempIn = 0;
        let tempOut = 0;
        res.data.content.forEach((s: any) => {
          if (s.amount.toString().substring(0, 1) == "-") {
            tempIn -= s.amount;
          } else {
            tempOut += s.amount;
          }
        });
        setBalanceIn(tempIn);
        setBalanceOut(tempOut);
        setTotalA(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        navigate("/login", { replace: true });
        dispatch(setLoading(false));
      });
  };

  const changePageB = async (newPage: any) => {
    setPageB(newPage);
    var dateNow = moment().subtract(90, "days").format("MM");
    var year = moment().subtract(90, "days").format("YYYY");

    // getHistory(dateNow, year);
    dispatch(setLoading(true));
    getOlderTransactions(dateOld, yearOld)
      .then((res: any) => {
        console.log(res.data, "consok");
        setTransaction(res.data.content);
        setTotalB(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changeSizeB = async (newSize: any) => {
    setPageB(newSize);
    var dateNow = moment().subtract(90, "days").format("MM");
    var year = moment().subtract(90, "days").format("YYYY");

    // getHistory(dateNow, year);
    dispatch(setLoading(true));
    getOlderTransactions(dateOld, yearOld)
      .then((res: any) => {
        console.log(res.data, "consok");
        setTransaction(res.data.content);
        setTotalB(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const goToDetail = async (item: String) => {
    setShowDetail(true);
    setDetail(item);
  };

  const transs = async () => {
    setTrans(true);
    dispatch(setLoading(true));
    var dateNow = moment().format("MM");
    var year = moment().format("YYYY");

    getHistory(dateNow, year);
  };

  const handleChangedateOld = (event: any) => {
    const value = event.target.value;
    setSelectedDateOld(value);
    var month = moment(value).format("MM");

    var year = moment(value).format("YYYY");
    setYearOld(year);
    setDateOld(month);
    transold(month, year);
    console.log(moment(value).format("MMMM-YYYY"));

    // setSelectedMonth(value);
  };

  const handleChangedate = (event: any) => {
    const value = event.target.value;
    setSelectedDate(value);
    var month = moment(value).format("MM");
    var year = moment(value).format("YYYY");
    setYearr(year);
    setDate(month);
    getHistory(month, year);
    console.log(moment(value).format("MMMM-YYYY"));
    console.log(event.target.value, "shabcbasb");
    // setSelectedMonth(value);
  };

  const [dateOld, setDateOld] = useState(
    moment().subtract(90, "days").format("MM")
  );
  const [yearOld, setYearOld] = useState(
    moment().subtract(90, "days").format("YYYY")
  );

  const transold = async (month: string, year: string) => {
    setTrans(false);

    // getHistory(dateNow, year);
    dispatch(setLoading(true));
    getOlderTransactions(month, year)
      .then((res: any) => {
        console.log(res.data, "consok");
        console.log(bulanOld, "yanggal");
        let tempIn = 0;
        let tempOut = 0;
        res.data.content.forEach((s: any) => {
          if (s.amount.toString().substring(0, 1) == "-") {
            tempIn -= s.amount;
          } else {
            tempOut += s.amount;
          }
        });
        setBalanceInOld(tempIn);
        setBalanceOutOld(tempOut);
        setTransactionOlder(res.data.content);
        setTotalB(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const options = [];

  for (let i = minOffset; i <= maxOffset; i++) {
    const newyear = parseInt(year) - i;
    options.push(<option value={newyear}>{newyear}</option>);
  }

  const gantiTahun = (event: any) => {
    setTahunOld(event.target.value);
    const value = event.target.value;
    setSelectedDateOld(value);
    var month = moment(value).format("MM");

    var year = moment(value).format("YYYY");
    setYearOld(year);
    setDateOld(month);
    transold(month, year);
    console.log(moment(value).format("MMMM-YYYY"));
  };

  const gantiTahunNew = (event: any) => {
    setTahun(event.target.value);
    const value = event.target.value;
    setSelectedDate(value);
    var month = moment(value).format("MM");
    var year = moment(value).format("YYYY");
    setYearr(year);
    setDate(month);
    getHistory(month, year);
    console.log(moment(value).format("MMMM-YYYY"));
    console.log(event.target.value, "shabcbasb");
  };

  return (
    <div className="font-montserrat bg-psp-primary pb-10">
      <StatsMutation />
      <div className="container-fluid">
        <div className="mx-auto w-full container md:-mt-30 -mt-20 p-4 px-5 relative justify-between items-left bg-white  shadow rounded-2xl">
          <div className="flex">
            <BackButton />
            <div className="font-bold text-4xl">{t("TRANSACTION.title")}</div>
          </div>
          <div className="container flex flex-row w-full p-2 rounded-lg">
            <div className="w-1/2">
              <p className="text-slate-400 text-2xl">
                {t("TRANSACTION.title")}
              </p>
              <button
                onClick={() => getHistory(month, year)}
                style={
                  trans
                    ? {
                      backgroundColor: customApp.app_accent_color,
                      color: isDarkColor(customApp.app_accent_color) ? 'white' : 'black',
                    }
                    : { backgroundColor: "white", color: "grey" }
                }
                className={`py-2 text-slate-400 rounded-xl border px-3 hover:bg-psp-btn-primary hover:text-white focus:text-white  mr-3`}
              >
                {t("TRANSACTION.new")}
              </button>
              <button
                onClick={() => transold(dateOld, yearOld)}
                style={
                  !trans
                    ? {
                      backgroundColor: customApp.app_accent_color,
                      color: isDarkColor(customApp.app_accent_color) ? 'white' : 'black',
                    }
                    : { backgroundColor: "white", color: "grey" }
                }
                className={`py-2 text-slate-400 rounded-xl border px-3 hover:bg-psp-btn-primary hover:text-white focus:text-white  mr-3`}
              >
                {t("TRANSACTION.older")}
              </button>
            </div>
            {!trans ? (
              <div className="w-1/2">
                <p className="text-slate-400 text-xl">
                  {t("TRANSACTION.info")}
                </p>
                <div className="flex flex-row  w-full">
                  <select
                    onChange={(e: any) => {
                      handleChangedateOld(e);
                    }}
                    className="py-2 text-slate-400 rounded-xl border px-3"
                    id="start"
                    name="start"
                    value={selectedDateOld}
                  >
                    <option value={tahunOld + "-" + "01"}>
                      {t("OTHER.month.january")}
                    </option>
                    <option value={tahunOld + "-" + "02"}>
                      {t("OTHER.month.february")}
                    </option>
                    <option value={tahunOld + "-" + "03"}>
                      {t("OTHER.month.march")}
                    </option>
                    <option value={tahunOld + "-" + "04"}>
                      {t("OTHER.month.april")}
                    </option>
                    <option value={tahunOld + "-" + "05"}>
                      {t("OTHER.month.may")}
                    </option>
                    <option value={tahunOld + "-" + "06"}>
                      {t("OTHER.month.june")}
                    </option>
                    <option value={tahunOld + "-" + "07"}>
                      {t("OTHER.month.july")}
                    </option>
                    <option value={tahunOld + "-" + "08"}>
                      {t("OTHER.month.august")}
                    </option>
                    <option value={tahunOld + "-" + "09"}>
                      {t("OTHER.month.september")}
                    </option>
                    <option value={tahunOld + "-" + "10"}>
                      {t("OTHER.month.october")}
                    </option>
                    <option value={tahunOld + "-" + "11"}>
                      {t("OTHER.month.november")}
                    </option>
                    <option value={tahunOld + "-" + "12"}>
                      {t("OTHER.month.december")}
                    </option>
                  </select>
                  <select
                    className="py-2 text-slate-400 rounded-xl border px-3 ml-4"
                    value={tahunOld}
                    onChange={(e: any) => gantiTahun(e)}
                  >
                    <option value={moment().subtract(5, "years").format("YYYY")}>{moment().subtract(5, "years").format("YYYY")}</option>
                    <option value={moment().subtract(4, "years").format("YYYY")}>{moment().subtract(4, "years").format("YYYY")}</option>
                    <option value={moment().subtract(3, "years").format("YYYY")}>{moment().subtract(3, "years").format("YYYY")}</option>
                    <option value={moment().subtract(2, "years").format("YYYY")}>{moment().subtract(2, "years").format("YYYY")}</option>
                    <option value={moment().subtract(1, "years").format("YYYY")}>{moment().subtract(1, "years").format("YYYY")}</option>
                    <option value={moment().subtract(0, "years").format("YYYY")}>{moment().subtract(0, "years").format("YYYY")}</option>
                    <option value={moment().subtract(-1, "years").format("YYYY")}>{moment().subtract(-1, "years").format("YYYY")}</option>
                    <option value={moment().subtract(-2, "years").format("YYYY")}>{moment().subtract(-2, "years").format("YYYY")}</option>
                  </select>
                </div>
              </div>
            ) : (
              <div className="w-1/2">
                <p className="text-slate-400 text-xl">
                  {t("TRANSACTION.info")}
                </p>
                <div className="flex flex-row  w-full">
                  <select
                    onChange={(e: any) => {
                      handleChangedate(e);
                    }}
                    className="py-2 text-slate-400 rounded-xl border px-3"
                    id="start"
                    name="start"
                    value={selectedDate}
                  >
                    <option value={tahun + "-" + "01"}>
                      {t("OTHER.month.january")}
                    </option>
                    <option value={tahun + "-" + "02"}>
                      {t("OTHER.month.february")}
                    </option>
                    <option value={tahun + "-" + "03"}>
                      {t("OTHER.month.march")}
                    </option>
                    <option value={tahun + "-" + "04"}>
                      {t("OTHER.month.april")}
                    </option>
                    <option value={tahun + "-" + "05"}>
                      {t("OTHER.month.may")}
                    </option>
                    <option value={tahun + "-" + "06"}>
                      {t("OTHER.month.june")}
                    </option>
                    <option value={tahun + "-" + "07"}>
                      {t("OTHER.month.july")}
                    </option>
                    <option value={tahun + "-" + "08"}>
                      {t("OTHER.month.august")}
                    </option>
                    <option value={tahun + "-" + "09"}>
                      {t("OTHER.month.september")}
                    </option>
                    <option value={tahun + "-" + "10"}>
                      {t("OTHER.month.october")}
                    </option>
                    <option value={tahun + "-" + "11"}>
                      {t("OTHER.month.november")}
                    </option>
                    <option value={tahun + "-" + "12"}>
                      {t("OTHER.month.december")}
                    </option>
                  </select>
                  <select
                    className="py-2 text-slate-400 rounded-xl border px-3 ml-4"
                    value={tahun}
                    onChange={(e: any) => gantiTahunNew(e)}
                  >
                    <option value={moment().subtract(5, "years").format("YYYY")}>{moment().subtract(5, "years").format("YYYY")}</option>
                    <option value={moment().subtract(4, "years").format("YYYY")}>{moment().subtract(4, "years").format("YYYY")}</option>
                    <option value={moment().subtract(3, "years").format("YYYY")}>{moment().subtract(3, "years").format("YYYY")}</option>
                    <option value={moment().subtract(2, "years").format("YYYY")}>{moment().subtract(2, "years").format("YYYY")}</option>
                    <option value={moment().subtract(1, "years").format("YYYY")}>{moment().subtract(1, "years").format("YYYY")}</option>
                    <option value={moment().subtract(0, "years").format("YYYY")}>{moment().subtract(0, "years").format("YYYY")}</option>
                    <option value={moment().subtract(-1, "years").format("YYYY")}>{moment().subtract(-1, "years").format("YYYY")}</option>
                    <option value={moment().subtract(-2, "years").format("YYYY")}>{moment().subtract(-2, "years").format("YYYY")}</option>
                  </select>
                </div>
                {/* <div className="flex flex-row  w-full">
                  <input
                    onChange={(e: any) => {
                      handleChangedate(e);
                    }}
                    className="py-2 text-slate-400 rounded-xl border px-3"
                    type="month"
                    id="start"
                    name="start"
                    max={moment().format("YYYY-MM")}
                    min={moment().subtract(90, "days").format("YYYY-MM")}
                    value={selectedDate}
                  />
                </div> */}
              </div>
            )}
          </div>
          {trans === true ? (
            <div className="mx-2 mt-7 border flex flex-row w-full rounded-xl py-4 px-3 mb-3 justify-between">
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-[1vw]">
                  {t("TRANSACTION.balanceIn")}
                </h1>
                <h1 className="font-light text-[1vw] text-green-500">
                  {" "}
                  {formatCurrency(balanceIn)}
                </h1>
              </div>
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-[1vw]">
                  {t("TRANSACTION.balanceOut")}
                </h1>
                <h1 className="font-light text-[1vw] text-rose-500">
                  {" "}
                  {formatCurrency(balanceOut * -1)}
                </h1>
              </div>
            </div>
          ) : (
            <div className="mx-2 mt-7 border flex flex-row w-full rounded-xl py-4 px-3 mb-3 justify-between">
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-[1vw]">
                  {t("TRANSACTION.balanceIn")}
                </h1>
                <h1 className="font-light text-[1vw] text-green-500">
                  {" "}
                  {formatCurrency(balanceInOld)}
                </h1>
              </div>
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-[1vw]">
                  {t("TRANSACTION.balanceOut")}
                </h1>
                <h1 className="font-light text-[1vw] text-rose-500">
                  {" "}
                  {formatCurrency(balanceOutOld * -1)}
                </h1>
              </div>
            </div>
          )}

          {trans === true ? (
            <div>
              {transaction.length < 1 ? (
                <div className="flex justify-center mt-4">
                  <span>{t("TRANSACTION.empety")}</span>
                </div>
              ) : (
                <div>
                  {transaction.map((item: any, i: any) => {
                    return (
                      <div
                        key={i}
                        className="mx-2 h-52 mt-7 border rounded-xl p-3 px-3 mb-3"
                      >
                        <p className="ml-2 text-xl font-semibold">
                          {item.transactionName}
                        </p>
                        <div className="mx-2 border-b-2 border-slate-300 p-0 mb-3 pb-1">
                          <span>{t("TRANSACTION.nominal")}</span>
                          <span className="float-right">
                            {formatCurrency(item.amount * -1)}
                          </span>
                        </div>
                        <div className="mx-2 border-b-2 border-slate-300 p-0 pb-1">
                          <span>{t("TRANSACTION.total")}</span>
                          <span className="float-right">{item.count}</span>
                        </div>
                        <button
                          onClick={() => goToDetail(item)}
                          style={{
                            backgroundColor: customApp.app_accent_color,
                          }}
                          className={`${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'} float-right py-2 w-[135px] rounded-lg mt-4 hover:shadow-xl`}
                        >
                          Detail
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* <div className="flex relative mt-10 justify-between">
                <div className="pt-2 w-1/4">
                  <p>
                    {t("OTHER.showing")} {pageA + 1} {t("OTHER.to")} {sizeA}{" "}
                    {t("OTHER.from")} {totalA} data
                  </p>
                </div>
                <div className="w-auto">
                  <div className="">
                    <select
                      onChange={(value) => {
                        changeSizeA(value.target.value);
                      }}
                      value={sizeA}
                      className="py-2 border rounded-lg bg-white"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                    <span className="ml-1">{t("TRANSACTION.page")}</span>
                  </div>
                </div>
                <div className="flex w-1/4">
                  <button
                    onClick={() => changePageA(pageA - 1)}
                    disabled={pageA === 0}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("OTHER.previous")}
                  </button>
                  <button
                    onClick={() => changePageA(pageA + 1)}
                    disabled={(pageA + 1) * sizeA > totalA}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("OTHER.next")}
                  </button>
                </div>
              </div> */}
            </div>
          ) : (
            <div>
              {transactionOlder.length < 1 ? (
                <div className="flex justify-center">
                  <span>{t("TRANSACTION.empety")}</span>
                </div>
              ) : (
                <div>
                  {transactionOlder.map((item: any, i: any) => {
                    return (
                      <div
                        key={i}
                        className="mx-2 h-52 mt-7 border rounded-xl p-3 px-3 mb-3"
                      >
                        <p className="ml-2 text-xl font-semibold">
                          {item.transactionName}
                        </p>
                        <div className="mx-2 border-b-2 border-slate-300 p-0 mb-3 pb-1">
                          <span>{t("TRANSACTION.nominal")}</span>
                          <span className="float-right">
                            {formatCurrency(item.amount * -1)}
                          </span>
                        </div>
                        <div className="mx-2 border-b-2 border-slate-300 p-0 pb-1">
                          <span>{t("TRANSACTION.total")}</span>
                          <span className="float-right">{item.count}</span>
                        </div>
                        <button
                          onClick={() => goToDetail(item)}
                          style={{
                            backgroundColor: customApp.app_accent_color,
                          }}
                          className={`${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'} float-right py-2 w-[135px] rounded-lg mt-4 hover:shadow-xl`}
                        >
                          Detail
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* <div className="flex relative mt-10 justify-between">
                <div className="pt-2 w-1/4">
                  <p>
                    {t("OTHER.showing")} {pageB + 1} {t("OTHER.to")} {sizeB}{" "}
                    {t("OTHER.from")} {totalB} data
                  </p>
                </div>
                <div className="w-auto">
                  <div className="">
                    <select
                      onChange={(value) => {
                        changeSizeB(value.target.value);
                      }}
                      value={sizeB}
                      className="py-2 border rounded-lg bg-white"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                    <span className="ml-1">{t("TRANSACTION.page")}</span>
                  </div>
                </div>
                <div className="flex w-1/4">
                  <button
                    onClick={() => changePageB(pageB - 1)}
                    disabled={pageB === 0}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("OTHER.previous")}
                  </button>
                  <button
                    onClick={() => changePageB(pageB + 1)}
                    disabled={(pageB + 1) * sizeB > totalB}
                    className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                  >
                    {t("OTHER.next")}
                  </button>
                </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
      <Transition
        show={showDetail}
        enter="transition-opacity duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-1/2 flex  my-6 mx-auto">
              <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="relative p-6 flex-auto">
                  <div className="flex flex-col border-b-2 mb-2">
                    <div className="w-full"></div>
                    <div className="text-center flex flex-col">
                      <span className="text-xl mt-2">{t("TOPUP.balance")}</span>
                      <span className="text-4xl font-bold text-lime-500 my-2">
                        {getBalance}
                      </span>
                      <span>
                        {moment(detail.dateTime).format("DD MMMM YYYY")}
                      </span>
                      <span className="font-bold mb-3">{user.name}</span>
                    </div>
                  </div>
                  <div className="flex flex-col w-full relative mt-3 gap-3">
                    <div className="flex flex-row w-full justify-between">
                      <span className="text-[1vw] font-montserrat">{t("INVOICE.name")}</span>
                      <span className="text-right text-[1vw] font-montserrat">{detail.transactionName}</span>
                    </div>

                    {
                      detail?.note != "" && <div className="flex flex-row w-full justify-between">
                        <span className="text-[1vw] font-montserrat">{t("MUTATION.note")}</span>
                        <span className="text-right text-[1vw] font-montserrat">{detail.note}</span>
                      </div>
                    }

                    <div className="flex flex-row w-full justify-between">
                      <span className="text-[1vw] font-montserrat">{t("TRANSACTION.amount")}</span>
                      <span className="text-right text-[1vw] font-montserrat">{detail.count}</span>
                    </div>
                    <div className="flex flex-row w-full justify-between">
                      <span className="text-[1vw] font-montserrat">{"Total"}</span>
                      <span className="text-right text-[1vw] font-montserrat" >{formatCurrency(detail.amount)}</span>
                    </div>
                  </div>
                  <div>
                    <div>
                      {/* <button
                          onClick={() => setShowDetail(false)}
                          className="w-full rounded-full bg-white border-2 border-blue-600 text-blue-600 boder-bl py-2.5"
                        >
                          Share
                        </button> */}
                      <button
                        onClick={() => setShowDetail(false)}
                        className="w-full text-white bg-red py-2.5 rounded-full mt-3"
                      >
                        {t("OTHER.close")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>
    </div>
  );
};

export default ComponentTransactionHistory;
